import ConctreteBed from './version03/Water_irrigation_Version03/Concrete_bed2.png.svg'
import P1 from './version03/Water_irrigation_Version03/P1.svg'
import P2 from './version03/Water_irrigation_Version03/P2.svg'
import P3 from './version03/Water_irrigation_Version03/P3.svg'
import P4 from './version03/Water_irrigation_Version03/P3.svg'
import mainLine from './Water_irrigation_Version03/Main_line_Red.svg.svg'
import P2_R from './version03/Water_irrigation_Version03/P2_R.svg'
import P2_G from './version03/Water_irrigation_Version03/P2_G.svg'
import antena from './version03/Water_irrigation_Version03/Pole_antenna.png'
import Water_meter from './version03/Water_irrigation_Version03/Water_Metre.svg'
import pressure_meter from './version03/Water_irrigation_Version03/Pressure_Metre.svg'
import { useRef, useState } from 'react'
import ProgressBar from './ProgressBar'
import ApiService from '../../services/apiService'
import { toast } from 'react-toastify'
import { useAppSelector } from '../../reduxToolkit/hooks'

const PoleImages = [P1, P2, P3, P4]

// ─── Per-valve component ──────────────────────────────────────────────────────
const SubChakValve = ({ valve,chackData }: { valve: any, chackData?:any }) => {
  const progressInterval = useRef<NodeJS.Timeout | null>(null)
  const [now, setNow] = useState<number>(0)
  const [progressBar, setProgressBar] = useState<boolean>(false)
  const elapsedRef = useRef<number>(0)
  const intervalId = useRef<NodeJS.Timeout | null>(null)
  const hasStoredResponse = useRef<boolean>(false)
  const firstResponseRef = useRef<number>(0)
  const lastResponseRef = useRef<number>(0)

  const valveNum = parseInt(valve.valveNumber?.match(/\d+/)?.[0] || '1', 10)
  const poleIndex = valveNum - 1
  const poleId = `P${valveNum}`
  const poleSrc = PoleImages[poleIndex]
  const valveSrc = valve.on ? P2_G : P2_R
  const sov = `SOV ${valveNum}`
  const role = useAppSelector((state: any) => state.role.role);
  // ✅ Har pole ka apna button position
// Har pole ke button ki FIXED position (valve-component ke relative)
const buttonPositions: Record<number, { top: string; left: string }> = {
  0: { top: '140px', left: '341px' },  // P1 - V01
  1: { top: '148px', left: '393px' },  // P2 - V02
  2: { top: '167px', left: '447px' },  // P3 - V03
  3: { top: '185px', left: '490px' },  // P4 - V04
}

  const btnPos = buttonPositions[poleIndex] ?? { top: '30px', marginLeft: '5px' }

  const stopProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }
    setNow(100); // ✅ response milte hi turant 100%
    setTimeout(() => {
      setNow(0);
      setProgressBar(false);
    }, 300); // thoda visual pause taaki 100% dikh jaye

  };

  const startProgressBar = () => {
    if (progressInterval.current) {
      clearInterval(progressInterval.current);
      progressInterval.current = null;
    }

    setNow(0);
    setProgressBar(true);

    const stepTime = 250;
    const duration = 35000;
    const capPercent = 95;
    const increment = capPercent / (duration / stepTime);

    let current = 0;

    progressInterval.current = setInterval(() => {
      current += increment;
      if (current >= 100) {
        current = 100;
        clearInterval(progressInterval.current!);
        progressInterval.current = null;
      }
      setNow(current);
    }, stepTime);
  };

  const sendSovCommand = async () => {
    try {
      const res = await ApiService.axiosApi("/command/sov/open/close", {
        method: "POST",
        data: {
          chakId: valve.chakId,
          sovNo: Number(sov.replace("SOV ", "")),
          open_Close: valve.on ? 0 : 1,
        },
      });

      if (res.success) {
        toast.success(`${valve.on ? "Valve Close" : "Valve Open"}`);
      } else {
        toast.error("failed. please retry again");
      }
    } catch (e) {
      console.error("error in sov open close:", e);

    } finally {
      stopProgressBar();
    }
  };


  const handleClick = () =>{
    if(role !== 'Administrator') return;
    console.log(chackData[0].romsAuto);
    if (chackData[0].romsAuto) {
      startProgressBar();
      sendSovCommand();
    } else {
      toast.error("Please select manual mode");
    }


  }
  return (
    <>
      {progressBar && <ProgressBar  totalpage={0}
          pageNumber={0}
          now={now}
          mystyle={{
            position: 'absolute',
            height: '25px',
            zIndex: 1000,
            backgroundColor: 'whitesmoke',
            borderRadius: '4px',
            width: '1136px',
            left: '-97px',
            bottom: '477px',
          }} />}

      {/* Valve state image */}
      <img
        id={`${poleId}_Red`}
        src={valveSrc}
        alt=""
        style={{ pointerEvents: 'none' }}
      />

      {/* ✅ No wrapper — direct absolute position */}
      <button
        onClick={ handleClick}
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          position: 'absolute',
          top: btnPos.top,    // fixed coordinate
          left: btnPos.left,  // fixed coordinate
          padding: '0px',
          zIndex: 10,
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          cursor: role == "Administrator" ? "pointer" : "default",
        }}
        className={valve.valveNumber}
      />

      {/* Pole image */}
      <img id={poleId} src={poleSrc} alt="" />
    </>
  )
}

const SubChak = ({ data,chackData }: { data: any[], chackData?:any }) => {
  const sortedData = [...data]
    .slice(0, 4)
    .sort((a, b) => {
      const aNum = parseInt(a.valveNumber?.match(/\d+/)?.[0] || '0', 10)
      const bNum = parseInt(b.valveNumber?.match(/\d+/)?.[0] || '0', 10)
      return aNum - bNum
    })

  return (
    <div className="mt-3 calendar-custom">
      <div id="valve-component">
        <img id="antena_pole" src={antena} alt="" style={{ height: '500px', width: '400px', position: 'absolute', zIndex: 3, top: '-60px', left: '450px' }} />
        <img id="water-meter2" src={Water_meter} alt="" style={{ height: '40px', width: '40px', position: 'absolute', left: '235px', top: '-20px', zIndex: -0.9 }} />
        <img id="pressure-meter2" src={pressure_meter} alt="" style={{ height: '40px', width: '40px', position: 'absolute', left: '320px', top: '15px', zIndex: -0.9 }} />
        <img id="Main_line_red" src={mainLine} alt="" style={{ zIndex: 2, height: '350px', width: '200px', position: 'absolute', transform: 'translate(-109px, -140px)' }} />

        {sortedData.map((valve) => (
          <SubChakValve key={valve.id} valve={valve} chackData={chackData} />
        ))}

        <img id="Concrete_Bed" src={ConctreteBed} alt="" />
      </div>
    </div>
  )
}

export default SubChak
